import { render, staticRenderFns } from "./ehc-branding.vue?vue&type=template&id=71394d7b"
import script from "./ehc-branding.vue?vue&type=script&lang=js"
export * from "./ehc-branding.vue?vue&type=script&lang=js"
import style0 from "./ehc-branding.vue?vue&type=style&index=0&id=71394d7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports